<template>
  <div class="column">
    <div class="row justify-end">
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('echeancePaiement')">{{$t('processes.export_echeance')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('prorogation')">{{$t('processes.export_prorogation')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList()">{{$t('processes.export')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" :to="{ name: 'suivi-de-mandat-gestion-form' }" icon-right="add_circle">{{$t('processes.create_suivi_de_mandat_gestion')}}</q-btn>
      </div>
    </div>
    <q-table flat wrap-cells
      :data="datas"
      :columns="columns"
      row-key="id"
      :rows-per-page-options="rowsPerPageOptions"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort>
      <q-tr slot="body" slot-scope="props" :props="props"
        @click.native="$router.push({ name: 'suivi-de-mandat-gestion-form', params: { id: props.row.id } })"
        class="cursor-pointer">
        <q-td v-for="col in props.cols" :key="col.name" :props="props" :auto-width="col.autoWidth">
          <div v-if="col.value" v-html="col.value" />
        </q-td>
      </q-tr>
    </q-table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import download from 'downloadjs'

export default {
  name: 'SuiviDeMandatGestionList',

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchFilters', 'mandatGestion')
  },

  meta () {
    return {
      title: 'Suivi de mandat de gestion'
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      suiviDeMandatGestionProcesses: 'processes/getProcesses',
      filters: 'processes/getFilters',
      rowsPerPageOptions: 'config/getRowsPerPageOptions'
    }),
    pagination: {
      ...mapGetters({ get: 'processes/getPagination' }),
      ...mapMutations({ set: 'processes/setPagination' })
    },
    filter () {
      return this.$route.meta.filter
    },
    datas () {
      return this.suiviDeMandatGestionProcesses.map(process => {
        const agents = process.agents.map(agent => `${agent['PRENOM']} ${agent['NOMITV']}`).join(', ')
        const entities = process.entities.map(entity => entity.label).join(', ')
        const agentsEntities = `${agents}${agents.length ? ' ' : ''}${entities}`

        return {
          ...process,
          agentsEntities
        }
      })
    },

    columns () {
      if (this.suiviDeMandatGestionProcesses.length === 0) return []
      else {
        const fields = ['agentsEntities', 'wallets', 'mandat_gestion_termine', 'date_fin', 'statut']
        const sortable = []

        return fields.map(key => {
          let label = this.$t(`processes.fields.${key}.label`)
          let align = 'left'
          let autoWidth = false
          let formatFn = val => val

          if (key === 'wallets') {
            label = 'Portefeuille'
            formatFn = val => {
              return val.map(wallet => wallet.NOMPTF).join(', ')
            }
          } if (key === 'agentsEntities') {
            label = 'Entité / Agent'
          } else if (key === 'mandat_gestion_termine') {
            formatFn = val => {
              return val ? 'Oui' : 'Non'
            }
          } else if (key === 'date_fin') {
            formatFn = val => this.$formatDate(val)
          } else if (key === 'statut') {
            formatFn = val => {
              if (val) return this.$t(`processes.status.${val}`)
              return ''
            }
            align = 'center'
          }

          return {
            name: key,
            align: align,
            label: label,
            field: key,
            format: formatFn,
            sortable: sortable.indexOf(key) >= 0,
            autoWidth: autoWidth
          }
        })
      }
    }
  },

  watch: {
    filters: {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    },
    '$route.meta.filter': {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    }
  },

  mounted () {
    // if (this.filters) {
    this.onRequest({ pagination: this.pagination })
    // }
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      { label: this.$t('processes.processAgence'), to: { name: '' } },
      { label: this.$t('processes.title.suivi_de_mandat_gestion'), to: { name: 'suivi-de-mandat-gestion-en-cours' } },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('processes.title.suivi_de_mandat_gestion'))
    this.$store.commit('pages/setTabs', [
      { name: 'suivi-de-mandat-gestion-en-cours', label: 'En cours', to: { name: 'suivi-de-mandat-gestion-en-cours' } },
      { name: 'suivi-de-mandat-gestion-archivés', label: 'Archivés', to: { name: 'suivi-de-mandat-gestion-archives' } }
    ])
  },

  methods: {
    onRequest ({ pagination, filter }) {
      this.$store.commit('processes/setPagination', pagination)
      this.loading = true

      let params = { ...pagination, filter: this.filter, typeProcess: 'mandatGestion' }
      if (this.filters) this.filters.forEach(filter => { params[filter.id] = filter.value })

      this.$store.dispatch('processes/fetchProcesses', params)
        .finally(() => { this.loading = false })
    },

    exportList (process) {
      let toExport = process || 'mandatGestion'
      this.$axios.get(`/api/processAgences/${toExport}/export`, {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'text/csv' }
      }).then(response => {
        download(response.data, `${toExport}.csv`)
      }).catch(this.$notifyError)
    }
  }
}
</script>
